import * as Sentry from '@sentry/browser';
import { CURRENT_USER_QUERY_KEY } from '@hotjar/user';
import { queryClient } from '@hotjar/webapp/utils/react-query';
import { log } from '@hotjar/insights-common/lib/log';
import { logout } from './api/api';
import {
  browserHistory,
  destroyProductUpdates,
  experimentService,
  getRoute,
  LOGIN,
  setCurrentSiteInLocalStorage,
  useTrack,
} from '../../webapp-dependencies';

interface UserLoginProps {
  logoutAndClearData: (callback?: () => void, persistAnonymousId?: boolean) => Promise<unknown>;
}

export function useUserLogin(): UserLoginProps {
  const track = useTrack();

  const logoutAndClearData = (
    callback?: () => void,
    persistAnonymousId = false,
  ): Promise<unknown> => {
    return logout()
      .then(() => queryClient.invalidateQueries(CURRENT_USER_QUERY_KEY))
      .then(() => {
        try {
          if (persistAnonymousId) {
            track.resetAndKeepAnonymousId();
          } else {
            track.logout();
          }

          setCurrentSiteInLocalStorage();
          destroyProductUpdates();
          experimentService.clearCache();
        } catch (error) {
          Sentry.captureException(error);
        } finally {
          // Execute any callbacks on logout.
          if (callback instanceof Function) {
            callback();
          } else {
            browserHistory.push(getRoute(LOGIN.path));
          }
        }
      })
      .catch((response) => log.warn(response));
  };

  return {
    logoutAndClearData,
  };
}
